import { Link } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";

export default function NotFound() {
  useReveal();

  return (
    <div className="pagewrap">
      <section className="hero" style={{ minHeight: "calc(100vh - 70px)" }}>
        <div className="hgrid" />
        <div className="hblob hb1" />
        <div className="hblob hb2" />
        <div className="hinner" style={{ gridTemplateColumns: "1fr", padding: "60px 0", textAlign: "center" }}>
          <div className="r" style={{ margin: "0 auto" }}>
            <div className="htag" style={{ margin: "0 auto 1.8rem" }}><span className="hdot" />Erreur 404</div>

            <h1 className="hh1" style={{ fontSize: "clamp(4rem,12vw,8rem)", marginBottom: "1rem" }}>
              <span className="hl2" style={{ display: "inline" }}>404</span>
            </h1>

            <h2 className="sh2" style={{ marginBottom: "1rem" }}>Cette page s'est <em>égarée.</em></h2>
            <p className="hsub" style={{ margin: "0 auto 2.5rem" }}>
              La page que vous cherchez n'existe pas, a été déplacée, ou l'adresse comporte une erreur. Pas d'inquiétude, on vous remet sur le bon chemin.
            </p>

            <div className="hctas" style={{ justifyContent: "center" }}>
              <Link className="btnf" to="/">Retour à l'accueil <span className="arr"><Ico name="arrowR" size={15} color="#fff" /></span></Link>
              <Link className="btno" to="/contact">Nous contacter</Link>
            </div>

            <div className="chiprow" style={{ justifyContent: "center", marginTop: "3rem" }}>
              <Link className="chip" to="/services" style={{ textDecoration: "none" }}>Services</Link>
              <Link className="chip" to="/packs" style={{ textDecoration: "none" }}>Packs</Link>
              <Link className="chip" to="/realisations" style={{ textDecoration: "none" }}>Réalisations</Link>
              <Link className="chip" to="/a-propos" style={{ textDecoration: "none" }}>À propos</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}